import axios from "axios";
import { v7 } from "uuid";

export const api_url = `${location.origin}/api`
export const api = axios.create({
    baseURL: api_url
})

api.interceptors.request.use(config => {
    if (localStorage.getItem('access_token')) {
        let access_token = localStorage.getItem('access_token');
        if (!config.params) {
            config.params = {};
        }
        config.params.access_token = access_token;
    }
    let params = {
        ...config.params,
        request_id: v7()
    }
    return {
        ...config,
        params
    };
}, err => {

    return Promise.reject(err);
})

api.interceptors.response.use(response => response, error => {
    if (error.response?.data?.error) {
        return Promise.reject(new Error(error.response.data.error))
    }
    return Promise.reject(error)
})


export default api